export const AssetProfileHeaders = Object.freeze({
  PROFILE_INFO: 'Profile Info',
  OPTIONS: 'Options',
  TESTPOINTS: 'Test Points',
});
